import listener from '@mailobj-browser/front/js/events/listeners/listener.js'
import click from '@mailobj-browser/front/js/events/types/click.js'
import object from '@mailobj-browser/front/js/utils/object.js'
import capture from '@mailobj-browser/front/js/events/options/capture.js'
import passive from '@mailobj-browser/front/js/events/options/passive.js'
import dropdown, { close } from '#utilities/js/lightboxes/menus/dropdown.js'

const onClick = object(listener, {
  type: click,
  capture,
  passive,
  task: close
})

export default action => {
  dropdown(action)
  onClick.listen(action)
}
